var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlogPortfolio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2218_7359",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 40,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.176 22.8003H46.8239C49.9589 22.8003 52.4999 25.3413 52.4999 28.4763V41.9072C52.4999 45.0422 49.9589 47.5832 46.8239 47.5832H39.1184L36.5114 52.0877C36.2804 52.5002 35.6699 52.5002 35.4389 52.0877L32.8319 47.5832H25.176C22.041 47.5832 19.5 45.0422 19.5 41.9072V28.4763C19.5 25.3413 22.041 22.8003 25.176 22.8003ZM27.1724 38.9372C26.5454 38.9372 25.9679 38.6732 25.5059 38.2277V38.7722H23.6414V30.5552H25.5059V33.1622C25.9679 32.7167 26.5289 32.4527 27.1724 32.4527C28.8884 32.4527 30.2909 33.9047 30.2909 35.7032C30.2909 37.5017 28.8884 38.9372 27.1724 38.9372ZM33.3104 38.7722H31.4294V33.3767C31.4294 32.4692 30.9344 32.0402 30.4229 32.0237V30.3572C31.6769 30.4397 33.3104 31.2647 33.3104 33.3602V38.7722ZM37.6169 38.9372C35.8184 38.9372 34.3664 37.4852 34.3664 35.6867C34.3664 33.8882 35.8184 32.4362 37.6169 32.4362C39.4154 32.4362 40.8674 33.8882 40.8674 35.6867C40.8674 37.4852 39.4154 38.9372 37.6169 38.9372ZM48.3418 38.3102C48.3418 40.8182 46.4278 41.3627 45.1078 41.4122V39.7622C46.2958 39.6962 46.5598 39.1187 46.5433 38.0792V37.9637C46.0813 38.4257 45.4873 38.7062 44.8273 38.7062C43.1113 38.7062 41.7089 37.3037 41.7089 35.5877C41.7089 33.8717 43.1113 32.4692 44.8273 32.4692C45.4873 32.4692 46.0813 32.7497 46.5433 33.2117V32.6507H48.3418V38.3102ZM46.6424 35.5712C46.6424 36.4127 45.9329 37.1057 45.0584 37.1057C44.1839 37.1057 43.4744 36.4127 43.4744 35.5712C43.4744 34.7297 44.1839 34.0367 45.0584 34.0367C45.9329 34.0367 46.6424 34.7297 46.6424 35.5712ZM28.5585 35.7032C28.5585 36.5777 27.849 37.3037 26.958 37.3037C26.067 37.3037 25.3575 36.5942 25.3575 35.7032C25.3575 34.8122 26.067 34.1027 26.958 34.1027C27.849 34.1027 28.5585 34.8122 28.5585 35.7032ZM39.1514 35.7032C39.1514 36.5447 38.4584 37.2377 37.6169 37.2377C36.7754 37.2377 36.0824 36.5447 36.0824 35.7032C36.0824 34.8617 36.7754 34.1687 37.6169 34.1687C38.4584 34.1687 39.1514 34.8617 39.1514 35.7032Z",
    fill: "#171719"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2218_7359)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 39.9998,
    height: 39.9999,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogPortfolio);
export default __webpack_public_path__ + "static/media/blog_portfolio.83f84d4f936900c37aa0db30cb8809a8.svg";
export { ForwardRef as ReactComponent };